module.exports = __webpack_public_path__ + "static/media/pt.2b7d0d7a.svg";